import * as CryptoJS from "crypto-js";
import {ENCRYPTION_URL_LIST} from "./defaults/requestUrl"
import {C_K, P_K} from "./defaults/data";

const fileToBase64 = (file) => {
    return new Promise(resolve => {
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        reader.onload = () => {
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
}
const blobToBase64 = (blob) => {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}
const formatter = new Intl.NumberFormat('IR', {});

const persianToEnglish = s => {
    if (!s) {
        return s;
    } else {
        return s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
    }

}
const Price = s => formatter.format(+s)


const calculatePrice = (price) => {
    const p = price + (price * 0.1)
    return p / 10;
}


function handleAToP(value) {
    var p_key = "";
    var aArray = value.split("_");
    for (var i = 0; i < aArray.length; i++) {
        p_key += String.fromCharCode(parseInt(aArray[i]));
    }
    return p_key;
}

function toFarsiNumber(n) {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return n
        .toString()
        .replace(/\d/g, x => farsiDigits[x]);
}

function needEncryption(value) {
    let isEncrypt = false
    ENCRYPTION_URL_LIST.forEach(item => {
        if (value.includes(item)) {
            isEncrypt = true
        }
    });

    return isEncrypt
}

async function importPublicKey(publicKeyPEM) {

    // Decode the PEM-encoded public key to ASN.1 format
    const publicKeyDER = atob(publicKeyPEM.replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\s/g, ''));
    let publicKeyArrayBuffer = new Uint8Array(publicKeyDER.length);
    for (let i = 0; i < publicKeyDER.length; i++) {
        publicKeyArrayBuffer[i] = publicKeyDER.charCodeAt(i);
    }

    return publicKeyArrayBuffer;
}

//encrypt any text (json) data with pub key
async function encryptWithRSA(publicKeyArrayBuffer, data) {

    const encoder = new TextEncoder();

    /*  try {*/

    const cryptoKey = await window.crypto.subtle.importKey(
        'spki',
        publicKeyArrayBuffer, {
            name: 'RSA-OAEP',
            hash: 'SHA-256',
        },
        false,
        ['encrypt']
    );

    const encryptedArrayBuffer = await window.crypto.subtle.encrypt({
            name: 'RSA-OAEP',
        },
        cryptoKey,
        encoder.encode(data)
    );

    // Convert the encrypted data to a hexadecimal string or base64, etc., as needed
    return btoa(String.fromCharCode.apply(null, new Uint8Array(encryptedArrayBuffer)));

    /*   } catch (error) {
           console.error('Encryption error:1234', error);
       }*/
}

function encryptAES(message, key) {
    // Convert the key to a WordArray
    let keyHex = CryptoJS.enc.Utf8.parse(key);

    // Generate a random IV
    let iv = CryptoJS.lib.WordArray.random(16); // 16 bytes (128 bits) for AES

    // Encrypt the message using AES CBC mode with PKCS#7 padding
    let encrypted = CryptoJS.AES.encrypt(message, keyHex, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    // Convert IV and ciphertext to base64-encoded strings
    let ivBase64 = CryptoJS.enc.Base64.stringify(iv);
    let cipherTextBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);

    // Return IV and ciphertext
    return {
        iv: ivBase64,
        ciphertext: cipherTextBase64
    };
}

async function handleEncryption(object, key) {

    const p_str = handleAToP(P_K);
    const C_str = handleAToP(C_K);

    try {
        const publicKeyArrayBuffer = await importPublicKey(p_str);
        const encryptedAESKey = await encryptWithRSA(publicKeyArrayBuffer, C_str);
        const encryptedData = encryptAES(JSON.stringify(object), C_str);

        return {
            'x_val': encryptedAESKey,
            'i_val': encryptedData.iv,
            'payload': encryptedData.ciphertext
        };
    } catch (error) {
        // Handle errors here
        console.error("Encryption failed:", error);
        throw error; // Rethrow the error for the caller to handle if needed
    }
}

function divarLinkGenerator({returnUrl, price, status},isInternal) {
    if(!isInternal){
        return "https://open-platform-redirect.divar.ir/completion"
    }
    const baseUrl = returnUrl && isDivarLink(returnUrl) ? returnUrl : 'https://divar.ir/my-divar/my-posts';

    const params = new URLSearchParams();

    if (price!==undefined&&price!==null) params.set('price', price);
    if (status!==undefined && status!==null) params.set('status', status);

    const queryString = params.toString();

    return queryString ? `${baseUrl}${baseUrl.includes('?')?'&':'?'}${queryString}` : baseUrl;


}


function authenticationPriceCalculator(type, defaultService, services, selectedItems, discount) {
    let price = 0;
    let payablePrice = 0;
    let priceWithDiscount = 0;
    let hasDiscount = false;
    selectedItems.forEach(selectedItem => {

        if (type === "add_on") {
            const discountPercent = discount ? discount.props[selectedItem.service_type].user_add_on : 0;
            if (discountPercent > 0) {
                hasDiscount = true;
            }
            if (selectedItems.length > 1) {
                price = price + selectedItem.prices.user_add_on.price
                payablePrice = payablePrice + selectedItem.prices.user_add_on_second.price;
                priceWithDiscount = priceWithDiscount + selectedItem.prices.user_add_on_second.price - (selectedItem.prices.user_add_on_second.price * discountPercent / 100)

            } else {
                price = price + selectedItem.prices.user_add_on.price
                payablePrice = payablePrice + selectedItem.prices.user_add_on.price;
                priceWithDiscount = priceWithDiscount + selectedItem.prices.user_add_on.price - (selectedItem.prices.user_add_on.price * discountPercent / 100)

            }
        } else {
            const discountPercent = discount ? discount.props[selectedItem.service_type].post_add_on : 0;
            if (discountPercent > 0) {
                hasDiscount = true;
            }
            if (selectedItems.length > 1) {
                price = price + selectedItem.prices.main.price
                payablePrice = payablePrice + selectedItem.prices.second.price;
                priceWithDiscount = priceWithDiscount + selectedItem.prices.second.price - (selectedItem.prices.second.price * discountPercent / 100)

            } else {
                price = price + selectedItem.prices.main.price
                payablePrice = payablePrice + selectedItem.prices.main.price;
                priceWithDiscount = priceWithDiscount + selectedItem.prices.main.price - (selectedItem.prices.main.price * discountPercent / 100)
            }

        }

    });

    return {
        payablePrice,
        price,
        showOff: price > payablePrice,
        priceWithDiscount,
        hasDiscount,

    }

    /*    let price = 0;
        let payablePrice = 0;
        selectedItems.forEach(item => {
            if(defaultService.has_off){
                payablePrice=payablePrice+item.prices[type]["off_"+defaultService.service_type];
            }else {
                payablePrice=payablePrice+item.prices[type][defaultService.service_type];
            }
            price=price+item.prices[type][item.service_type]
        })


        return {
            payablePrice,
            price,
            showOff: price > payablePrice,
        }*/

}


function handleInputJustUseNumber(e) {
    const charCode = e.which || e.keyCode;
    const charStr = String.fromCharCode(charCode);
    const persianDigits = /[\u06F0-\u06F9]/;
    const digits = /[0-9]/;
    if (!digits.test(charStr) && !persianDigits.test(charStr)) {
        e.preventDefault();
    }
}

function calculateOtpTimer(timeStamp, timerCount) {

    return timerCount - (Math.floor(Date.now() / 1000) - timeStamp);
}

function isDivarLink(link) {
    // Define the regular expression for divar.ir and its subdomains
    const divarRegex = /^https:\/\/(?:[a-zA-Z0-9-]+\.)?divar\.ir(\/?|\/.+)$/;

    // Test the link against the regular expression
    return divarRegex.test(link);
}

function isVenifyLink(link) {
    // Define the regular expression for venify.ir and its subdomains
    const venifyRegex = /^https:\/\/(?:[a-zA-Z0-9-]+\.)?venify\.ir(\/?|\/.+)$/;

    // Test the link against the regular expression
    return venifyRegex.test(link);
}

function isVeneshLink(link) {
    // Define the regular expression for venesh.ir and its subdomains
    const veneshRegex = /^https:\/\/(?:[a-zA-Z0-9-]+\.)?venesh\.ir(\/?|\/.+)$/;

    // Test the link against the regular expression
    return veneshRegex.test(link);
}

function safeRedirect(link, onFailed = () => {
}) {
    if (isVeneshLink(link)) {
        // Redirect to the venesh link
        window.location.href=link;
    } else if (isVenifyLink(link)) {
        // Redirect to the venify link
        window.location.href = link;
    } else if (isDivarLink(link)) {
        // Redirect to the divar link
        window.location.href = link;
    } else {
        onFailed()
    }
}

export {

    toFarsiNumber,
    divarLinkGenerator,
    needEncryption,
    handleEncryption,
    Price,
    blobToBase64,
    fileToBase64,
    authenticationPriceCalculator,
    calculatePrice,
    handleInputJustUseNumber,
    persianToEnglish,
    calculateOtpTimer,
    isVenifyLink,
    isVeneshLink,
    safeRedirect,
}